module.exports = __webpack_public_path__ + "img/diapositiva-10-1.0e8b8852.jpg";